<div class="inside-container">
    <div fxLayout="row" fxLayoutGap="5px">
        <div fxFlex="75" fxLayoutAlign="start center">
            <h3 class="tab-header" i18n="@@61de205e5fae1f61292a71f083c0c144dd2fc54e" t="61de205e5fae1f61292a71f083c0c144dd2fc54e">Internal Users Dashboard</h3>
            <a target="_blank" [href]="helpUrl">
                <tsl-icon size="small" class="header-help-icon">help</tsl-icon>
            </a>
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="5px">
        <div fxFlex="70"></div>
        <div class="inside-container-rating mat-elevation-z2" fxFlex="30" fxLayout="column"
            fxLayoutAlign="center center" fxLayoutGap="5px">
            <div fxLayout="row">
                <h3 class="internal-title">
                    <span i18n="@@abb470ad21cf8baa0f786ae2209358601842ed4e" t="abb470ad21cf8baa0f786ae2209358601842ed4e">Avg Rating: </span>
                    {{avgRate}}
                    <tsl-icon>star</tsl-icon>
                </h3>&nbsp;
                <h3 class="internal-title">({{supplierRatings.length}})<span i18n="@@30f63b5edc926dd74daa7f50a7b43b8866425511" t="30f63b5edc926dd74daa7f50a7b43b8866425511"> reviews</span></h3>
            </div>
            <div fxLayout="row">
                <h3 class="internal-title"><span i18n="@@d730e7ceac9bf2927dfc99084aca999bb1c3a23a" t="d730e7ceac9bf2927dfc99084aca999bb1c3a23a">Supplier status: </span>{{status}}</h3>&nbsp;
                <div>
                    <tsl-chip *ngIf="this.profile && showBlackListed && isBlackListed" i18n="@@60b3077df6419d415ce370b92fdc1cd17ac044a8" t="60b3077df6419d415ce370b92fdc1cd17ac044a8">Is Blacklisted</tsl-chip>
                </div>
            </div>
        </div>
    </div>
    <br />

    <!-- search box -->
    <div>
        <div fxLayoutAlign="space-around end" fxLayoutGap="10px">
            <tsl-form-field fxFlex>
                <tsl-label i18n="@@607de17c2a755f65775881c19e276e7c933bcf94" t="607de17c2a755f65775881c19e276e7c933bcf94">Category</tsl-label>
                <tsl-select id="filter_category" fullWidth [(ngModel)]="filter.category">
                    <tsl-option *ngFor="let item of ratePurpose$ | async" [value]="item.id">
                        {{ translateService.get(item.purpose) }}</tsl-option>
                </tsl-select>
            </tsl-form-field>

            <tsl-form-field fxFlex>
                <tsl-label i18n="@@13236eb36ad30eb4e6b90c567feca13810d95f58" t="13236eb36ad30eb4e6b90c567feca13810d95f58">Reviewed by</tsl-label>
                <tsl-select id="filter_createdBy" fullWidth [(ngModel)]="filter.createdBy">
                    <tsl-option *ngFor="let item of createdUsers" [value]="item">
                        {{ item }}</tsl-option>
                </tsl-select>
            </tsl-form-field>

            <tsl-form-field fxFlex>
                <tsl-label i18n="@@d821bd45daae1615b4b43d06281e95048ec497c5" t="d821bd45daae1615b4b43d06281e95048ec497c5">Rate</tsl-label>
                <tsl-select id="filter_rate" triggerIcon="star" fullWidth [(ngModel)]="filter.rate">
                    <tsl-option value="1" i18n="@@69dcaa14edc83369180975bd3176a4355f803f17" t="69dcaa14edc83369180975bd3176a4355f803f17">
                        Very poor
                    </tsl-option>
                    <tsl-option value="2" i18n="@@e91d18c1293597eac6275945809d2440e7c56d2c" t="e91d18c1293597eac6275945809d2440e7c56d2c">
                        Poor
                    </tsl-option>
                    <tsl-option value="3" i18n="@@9a87465dc05b8d7b7ea9df0c83029575385dc561" t="9a87465dc05b8d7b7ea9df0c83029575385dc561">
                        Average
                    </tsl-option>
                    <tsl-option value="4" i18n="@@a617fdf04ad90452dd60dbc608b20f700d344317" t="a617fdf04ad90452dd60dbc608b20f700d344317">
                        Good
                    </tsl-option>
                    <tsl-option value="5" i18n="@@9183e8745594426bbb573ce2fdb4826efe2e3c6e" t="9183e8745594426bbb573ce2fdb4826efe2e3c6e">
                        Excellent
                    </tsl-option>
                </tsl-select>
            </tsl-form-field>

            <tsl-form-field fxFlex>
                <tsl-label i18n="@@c4adf8c47b7ec27047d8aa885a8a3a6ce03cf6df" t="c4adf8c47b7ec27047d8aa885a8a3a6ce03cf6df">Keyword seach</tsl-label>
                <input type="text" tslInput fullWidth [(ngModel)]="filter.keywordSearch">
            </tsl-form-field>
        </div>
        <div class="left">
            <button tsl-button color="blue" size="small" (click)="onFilter()" i18n="@@7e892ba15f2c6c17e83510e273b3e10fc32ea016" t="7e892ba15f2c6c17e83510e273b3e10fc32ea016">Search</button>
            <button tsl-button color="black" outline size="small" (click)="onClearFilter()" i18n="@@99ee4faa69cd2ea8e3678c1f557c0ff1f05aae46" t="99ee4faa69cd2ea8e3678c1f557c0ff1f05aae46">Clear</button>
        </div>
    </div>
    <br>

    <div>
        <div class="right-container">
            <button tsl-button color="black" size="small" outline (click)="onAdd()" i18n="@@fbfdeefd85d6ab9cf3972adcdfc5b768a4fa918b" t="fbfdeefd85d6ab9cf3972adcdfc5b768a4fa918b">
                Add Supplier Rating</button>
        </div>
        <table tsl-table tslSort [dataSource]="datasource" (tslSortChange)="onSortChange($event)">
            <ng-container tslColumnDef="category">
                <th tsl-sort-header tsl-header-cell *tslHeaderCellDef i18n="@@607de17c2a755f65775881c19e276e7c933bcf94" t="607de17c2a755f65775881c19e276e7c933bcf94"> Category </th>
                <td tsl-cell *tslCellDef="let item"> {{ translateService.get(item.ratePurpose) }} </td>
            </ng-container>

            <ng-container tslColumnDef="createdBy">
                <th tsl-sort-header tsl-header-cell *tslHeaderCellDef i18n="@@13236eb36ad30eb4e6b90c567feca13810d95f58" t="13236eb36ad30eb4e6b90c567feca13810d95f58"> Reviewed by </th>
                <td tsl-cell *tslCellDef="let item"> {{ item.createdBy }} </td>
            </ng-container>

            <ng-container tslColumnDef="createdOn">
                <th tsl-sort-header tsl-header-cell *tslHeaderCellDef i18n="@@d78200333b54c1ecff22a167b2bbbcb18b8fad17" t="d78200333b54c1ecff22a167b2bbbcb18b8fad17"> Reviewed on </th>
                <td tsl-cell *tslCellDef="let item"> {{ item.createdOn | date }} </td>
            </ng-container>

            <ng-container tslColumnDef="rate">
                <th tsl-sort-header tsl-header-cell *tslHeaderCellDef i18n="@@3373875980daf0ae01a660f36068241450a4c54c" t="3373875980daf0ae01a660f36068241450a4c54c"> Rating </th>
                <td tsl-cell *tslCellDef="let item">
                    <tsl-icon size="small" *ngFor="let i of getStars(item.rate)">star</tsl-icon>
                </td>
            </ng-container>

            <ng-container tslColumnDef="title">
                <th tsl-sort-header tsl-header-cell *tslHeaderCellDef i18n="@@1c9f4ce85f463611a742ff1835a9878489d5104a" t="1c9f4ce85f463611a742ff1835a9878489d5104a"> Title </th>
                <td tsl-cell *tslCellDef="let item"> {{ item.subject }} </td>
            </ng-container>

            <ng-container tslColumnDef="action">
                <th tsl-header-cell *tslHeaderCellDef i18n="@@1bd5e17c9582661e20763a7634ef07881e33bbd7" t="1bd5e17c9582661e20763a7634ef07881e33bbd7"> Action </th>
                <td tsl-cell *tslCellDef="let item">
                    <button tsl-icon-button matTooltip="View" (click)="onView(item)">
                        <tsl-icon status="primary">visibility</tsl-icon>
                    </button>
                </td>
            </ng-container>

            <tr tsl-header-row *tslHeaderRowDef="displayedColumns"></tr>
            <tr tsl-row *tslRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <tsl-pagination [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex"
            showFirstLastButtons (pageChange)="onPageChange($event)" [itemsPerPageLabel]="translateService.get('ItemsPerPage')" [total]="totalRecords"></tsl-pagination>
    </div>
</div>